export default {
  api: '/api',
  useMock: true,
  timeout: 30000
}
